<template>
  <KycVerifyModalOnfido v-if="kycVerifyModalData.kycProvider === 'onfido'" />
  <KycVerifyModalJumio v-else-if="kycVerifyModalData.kycProvider === 'jumio'" />
</template>

<script>
  export default {
    name: 'KycVerifyModalWrapper',
    components: {
      KycVerifyModalJumio: () => import('~/components/shared/kyc-verify-modal/jumio.vue'),
      KycVerifyModalOnfido: () => import('~/components/shared/kyc-verify-modal/onfido.vue'),
    },
    computed: {
      kycVerifyModalData() {
        return this.$store.getters['eKyc/get_verify_modal_data']
      },
    },
  }
</script>
